import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { isNonEmptyArray } from '../../../base/common/arrays.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { KeyChord } from '../../../base/common/keyCodes.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { EditorAction, registerEditorAction, registerEditorContribution } from '../../browser/editorExtensions.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { CharacterSet } from '../../common/core/characterClassifier.js';
import { Range } from '../../common/core/range.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { DocumentRangeFormattingEditProviderRegistry, OnTypeFormattingEditProviderRegistry } from '../../common/modes.js';
import { IEditorWorkerService } from '../../common/services/editorWorkerService.js';
import { getOnTypeFormattingEdits, alertFormattingEdits, formatDocumentRangesWithSelectedProvider, formatDocumentWithSelectedProvider } from './format.js';
import { FormattingEdit } from './formattingEdit.js';
import * as nls from '../../../nls.js';
import { CommandsRegistry, ICommandService } from '../../../platform/commands/common/commands.js';
import { ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { Progress, IEditorProgressService } from '../../../platform/progress/common/progress.js';

var FormatOnType = /*#__PURE__*/function () {
  function FormatOnType(editor, _workerService) {
    var _this = this;

    _classCallCheck(this, FormatOnType);

    this._workerService = _workerService;
    this._callOnDispose = new DisposableStore();
    this._callOnModel = new DisposableStore();
    this._editor = editor;

    this._callOnDispose.add(editor.onDidChangeConfiguration(function () {
      return _this._update();
    }));

    this._callOnDispose.add(editor.onDidChangeModel(function () {
      return _this._update();
    }));

    this._callOnDispose.add(editor.onDidChangeModelLanguage(function () {
      return _this._update();
    }));

    this._callOnDispose.add(OnTypeFormattingEditProviderRegistry.onDidChange(this._update, this));
  }

  _createClass(FormatOnType, [{
    key: "dispose",
    value: function dispose() {
      this._callOnDispose.dispose();

      this._callOnModel.dispose();
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this2 = this;

      // clean up
      this._callOnModel.clear(); // we are disabled


      if (!this._editor.getOption(41
      /* formatOnType */
      )) {
        return;
      } // no model


      if (!this._editor.hasModel()) {
        return;
      }

      var model = this._editor.getModel(); // no support


      var _OnTypeFormattingEdit = OnTypeFormattingEditProviderRegistry.ordered(model),
          _OnTypeFormattingEdit2 = _slicedToArray(_OnTypeFormattingEdit, 1),
          support = _OnTypeFormattingEdit2[0];

      if (!support || !support.autoFormatTriggerCharacters) {
        return;
      } // register typing listeners that will trigger the format


      var triggerChars = new CharacterSet();

      var _iterator = _createForOfIteratorHelper(support.autoFormatTriggerCharacters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ch = _step.value;
          triggerChars.add(ch.charCodeAt(0));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._callOnModel.add(this._editor.onDidType(function (text) {
        var lastCharCode = text.charCodeAt(text.length - 1);

        if (triggerChars.has(lastCharCode)) {
          _this2._trigger(String.fromCharCode(lastCharCode));
        }
      }));
    }
  }, {
    key: "_trigger",
    value: function _trigger(ch) {
      var _this3 = this;

      if (!this._editor.hasModel()) {
        return;
      }

      if (this._editor.getSelections().length > 1) {
        return;
      }

      var model = this._editor.getModel();

      var position = this._editor.getPosition();

      var canceled = false; // install a listener that checks if edits happens before the
      // position on which we format right now. If so, we won't
      // apply the format edits

      var unbind = this._editor.onDidChangeModelContent(function (e) {
        if (e.isFlush) {
          // a model.setValue() was called
          // cancel only once
          canceled = true;
          unbind.dispose();
          return;
        }

        for (var i = 0, len = e.changes.length; i < len; i++) {
          var change = e.changes[i];

          if (change.range.endLineNumber <= position.lineNumber) {
            // cancel only once
            canceled = true;
            unbind.dispose();
            return;
          }
        }
      });

      getOnTypeFormattingEdits(this._workerService, model, position, ch, model.getFormattingOptions()).then(function (edits) {
        unbind.dispose();

        if (canceled) {
          return;
        }

        if (isNonEmptyArray(edits)) {
          FormattingEdit.execute(_this3._editor, edits, true);
          alertFormattingEdits(edits);
        }
      }, function (err) {
        unbind.dispose();
        throw err;
      });
    }
  }]);

  return FormatOnType;
}();

FormatOnType.ID = 'editor.contrib.autoFormat';
FormatOnType = __decorate([__param(1, IEditorWorkerService)], FormatOnType);

var FormatOnPaste = /*#__PURE__*/function () {
  function FormatOnPaste(editor, _instantiationService) {
    var _this4 = this;

    _classCallCheck(this, FormatOnPaste);

    this.editor = editor;
    this._instantiationService = _instantiationService;
    this._callOnDispose = new DisposableStore();
    this._callOnModel = new DisposableStore();

    this._callOnDispose.add(editor.onDidChangeConfiguration(function () {
      return _this4._update();
    }));

    this._callOnDispose.add(editor.onDidChangeModel(function () {
      return _this4._update();
    }));

    this._callOnDispose.add(editor.onDidChangeModelLanguage(function () {
      return _this4._update();
    }));

    this._callOnDispose.add(DocumentRangeFormattingEditProviderRegistry.onDidChange(this._update, this));
  }

  _createClass(FormatOnPaste, [{
    key: "dispose",
    value: function dispose() {
      this._callOnDispose.dispose();

      this._callOnModel.dispose();
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this5 = this;

      // clean up
      this._callOnModel.clear(); // we are disabled


      if (!this.editor.getOption(40
      /* formatOnPaste */
      )) {
        return;
      } // no model


      if (!this.editor.hasModel()) {
        return;
      } // no formatter


      if (!DocumentRangeFormattingEditProviderRegistry.has(this.editor.getModel())) {
        return;
      }

      this._callOnModel.add(this.editor.onDidPaste(function (_ref) {
        var range = _ref.range;
        return _this5._trigger(range);
      }));
    }
  }, {
    key: "_trigger",
    value: function _trigger(range) {
      if (!this.editor.hasModel()) {
        return;
      }

      if (this.editor.getSelections().length > 1) {
        return;
      }

      this._instantiationService.invokeFunction(formatDocumentRangesWithSelectedProvider, this.editor, range, 2
      /* Silent */
      , Progress.None, CancellationToken.None).catch(onUnexpectedError);
    }
  }]);

  return FormatOnPaste;
}();

FormatOnPaste.ID = 'editor.contrib.formatOnPaste';
FormatOnPaste = __decorate([__param(1, IInstantiationService)], FormatOnPaste);

var FormatDocumentAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(FormatDocumentAction, _EditorAction);

  var _super = _createSuper(FormatDocumentAction);

  function FormatDocumentAction() {
    _classCallCheck(this, FormatDocumentAction);

    return _super.call(this, {
      id: 'editor.action.formatDocument',
      label: nls.localize('formatDocument.label', "Format Document"),
      alias: 'Format Document',
      precondition: ContextKeyExpr.and(EditorContextKeys.notInCompositeEditor, EditorContextKeys.writable, EditorContextKeys.hasDocumentFormattingProvider),
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.editorTextFocus, EditorContextKeys.hasDocumentFormattingProvider),
        primary: 1024
        /* Shift */
        | 512
        /* Alt */
        | 36
        /* KEY_F */
        ,
        linux: {
          primary: 2048
          /* CtrlCmd */
          | 1024
          /* Shift */
          | 39
          /* KEY_I */

        },
        weight: 100
        /* EditorContrib */

      },
      contextMenuOpts: {
        when: EditorContextKeys.hasDocumentFormattingProvider,
        group: '1_modification',
        order: 1.3
      }
    });
  }

  _createClass(FormatDocumentAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var instaService, progressService;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!editor.hasModel()) {
                  _context.next = 5;
                  break;
                }

                instaService = accessor.get(IInstantiationService);
                progressService = accessor.get(IEditorProgressService);
                _context.next = 5;
                return progressService.showWhile(instaService.invokeFunction(formatDocumentWithSelectedProvider, editor, 1
                /* Explicit */
                , Progress.None, CancellationToken.None), 250);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return FormatDocumentAction;
}(EditorAction);

var FormatSelectionAction = /*#__PURE__*/function (_EditorAction2) {
  _inherits(FormatSelectionAction, _EditorAction2);

  var _super2 = _createSuper(FormatSelectionAction);

  function FormatSelectionAction() {
    _classCallCheck(this, FormatSelectionAction);

    return _super2.call(this, {
      id: 'editor.action.formatSelection',
      label: nls.localize('formatSelection.label', "Format Selection"),
      alias: 'Format Selection',
      precondition: ContextKeyExpr.and(EditorContextKeys.writable, EditorContextKeys.hasDocumentSelectionFormattingProvider),
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.editorTextFocus, EditorContextKeys.hasDocumentSelectionFormattingProvider),
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 36
        /* KEY_F */
        ),
        weight: 100
        /* EditorContrib */

      },
      contextMenuOpts: {
        when: ContextKeyExpr.and(EditorContextKeys.hasDocumentSelectionFormattingProvider, EditorContextKeys.hasNonEmptySelection),
        group: '1_modification',
        order: 1.31
      }
    });
  }

  _createClass(FormatSelectionAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var instaService, model, ranges, progressService;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (editor.hasModel()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                instaService = accessor.get(IInstantiationService);
                model = editor.getModel();
                ranges = editor.getSelections().map(function (range) {
                  return range.isEmpty() ? new Range(range.startLineNumber, 1, range.startLineNumber, model.getLineMaxColumn(range.startLineNumber)) : range;
                });
                progressService = accessor.get(IEditorProgressService);
                _context2.next = 8;
                return progressService.showWhile(instaService.invokeFunction(formatDocumentRangesWithSelectedProvider, editor, ranges, 1
                /* Explicit */
                , Progress.None, CancellationToken.None), 250);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return FormatSelectionAction;
}(EditorAction);

registerEditorContribution(FormatOnType.ID, FormatOnType);
registerEditorContribution(FormatOnPaste.ID, FormatOnPaste);
registerEditorAction(FormatDocumentAction);
registerEditorAction(FormatSelectionAction); // this is the old format action that does both (format document OR format selection)
// and we keep it here such that existing keybinding configurations etc will still work

CommandsRegistry.registerCommand('editor.action.format', function (accessor) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var editor, commandService;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            editor = accessor.get(ICodeEditorService).getFocusedCodeEditor();

            if (!(!editor || !editor.hasModel())) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return");

          case 3:
            commandService = accessor.get(ICommandService);

            if (!editor.getSelection().isEmpty()) {
              _context3.next = 9;
              break;
            }

            _context3.next = 7;
            return commandService.executeCommand('editor.action.formatDocument');

          case 7:
            _context3.next = 11;
            break;

          case 9:
            _context3.next = 11;
            return commandService.executeCommand('editor.action.formatSelection');

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
});